import _ from 'lodash';
import React, { useContext, useMemo } from 'react';

const sidePanelContextValue = {
	summaryOptions: {
		name: OptionUtils.getLabel('h2.am.ShiftingContext', 'realTimeScheduleStatistics'),
		sections: [
			// 'summarySection',
			'immediateSummarySection',
			'workHourRangeSection',
			'shiftSummary',
			'workLabelSummary',
			'overTimeSummary'
		]
	}
};
export const SidePanelContext = React.createContext(sidePanelContextValue);
export const SidePanelProvider = ({ children, ...props }) => {
	const value = useMemo(() => {
		return _.merge(_.cloneDeep(sidePanelContextValue), _.cloneDeep(props));
	}, [props]);
	return <SidePanelContext.Provider value={value}>{children}</SidePanelContext.Provider>;
};
export const useSidePanelContext = () => useContext(SidePanelContext);

export const ShiftingContext = React.createContext({
	shifts: [],
	workLabels: [],
	calendarLeaves: [],
	calendarLeaveMap: {},
	shiftMap: {},
	labelLimit: 4,
	workLabelMap: {},
	api: 'am30100',
});
ShiftingContext.displayName = 'ShiftingContext';

export const ControlPanelContext = React.createContext({
	cleanup: false,
	shiftMax: 1,
	calendarLeave: null,
	shifts: [],
	workLabel: [],
	sort: [],
	setSort: () => {},
});
ControlPanelContext.displayName = 'ControlPanelContext';

export const RowContext = React.createContext({
	rebuild: () => {},
	reCalcTotalHours: () => {},
});
RowContext.displayName = 'RowContext';

export const ShiftingActionContext = React.createContext({
	// 這邊列出來只是方便開發時知道有什麼
	onNameClick: undefined,
	onHourClick: undefined,
	onDateClick: undefined,
	// TODO 預設應該是都 undefined，用來判斷需不需要綁 onClick
	stampOn: () => {},
	removeDayType: () => {},
	clickShift: () => {},
	removeShift: () => {},
	clickTag: () => {},
	removeTag: () => {},
	reloadOptions:  async () => {},
	openLeaveDetailDlg: undefined
});
ShiftingActionContext.displayName = 'ShiftingActionContext';
